<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/V1ILf5/tc-custom/9781631953743.jpg?1704761281213" alt="This image is the cover for the book Growing Together in Christ"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Growing Together in Christ
      </h1>
      <p class="bookDescription body article font2">
        <b><i>Growing Together in Christ</i> provides several stepping-stones for couples to use as they start the journey of following Christ together—daily and intentionally.</b><br/><br/><i>Growing Together in Christ</i> offers several classic spiritual disciplines couples may apply to their devotional life, including: How to use the Bible in a brief devotional timeHow to pray simply and effectivelyHow to build a generous life togetherHow gratitude sweetens a marriage<br/> These spiritual disciplines rest on centuries of fruitful practice. Utilizing these proven spiritual disciplines to build one’s devotional life promises similar fruit—growing together in Christ for the sake of others. <i>Growing Together in Christ</i> grew from William Hutcheson’s own desire for a deeper devotional life with his bride and out of the spiritual need of couples he pastored or coached. He applied several basic spiritual disciplines, usually used by individuals, to a couple’s devotional life. The results compare to taking two single v-hulled boats and fitting them together as a twin-hulled catamaran. Couples can begin to retool their marriage today with <i>Growing Together in Christ</i>.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        William Hutcheson
      </h2>
      
      <p class="authorDescription body article">Before surrendering to the ministry for 38 years, <B>William Hutcheson</B> prepared for a clinical counseling career. Even though his masters and doctoral degrees focused on pastoral duties, he expressed the passion for helping couples by developing a comprehensive and successful marriage preparation process. He later expanded that process to help married couples as well. Bill’s first book <I>Marriage Maximized: The Guide to a Purposeful and Passionate Relationship</I>, also published by Morgan James Publisher, outlined that process for couples wishing to improve their relationship. This second book, <I>The Maximized Couple’s Devotional Life: A Guide to Growing in Christ Together for the Sake of Others</I>, helps couples to further maximize their marriage by developing together a robust devotional life. Bill has been married over four decades and lives with his beloved, Mary Beth, in Dahlonega, Georgia.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Morgan James Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?463e2b64